import { IRowHookInput } from 'dromo-uploader-js/dist/interfaces'
import { SiteAction } from 'common/types'

export function getSitesNeedingSiteActions(
  isUpdate: boolean,
  records: IRowHookInput[]
): { sitesNeedingSiteActions: IRowHookInput[]; sitesToSkip: IRowHookInput[] } {
  // on initial load, fetch actions for ALL rows
  if (!isUpdate) {
    return { sitesNeedingSiteActions: records, sitesToSkip: [] }
  }

  const sitesNeedingSiteActions: IRowHookInput[] = []
  const sitesToSkip: IRowHookInput[] = []

  // on update, only update records that were marked as invalid (check if the user has fixed them)
  for (const site of records) {
    const siteNeedsReview =
      site.row.siteAction.value === SiteAction.Review &&
      !site.row.maybeSold?.value // don't compare potentially sold sites to existing db records, we added this record from the db
    if (siteNeedsReview || !site.row.siteAction.value) {
      // site was invalid or has no recommended action
      sitesNeedingSiteActions.push(site)
    } else {
      sitesToSkip.push(site)
    }
  }

  return { sitesNeedingSiteActions, sitesToSkip }
}
